import { cn } from '@/lib/cn';
import type { ServiceHealth } from '@/types';

interface StatusIndicatorProps {
  label: string;
  status: ServiceHealth;
  detail?: string;
}

const dotColor: Record<ServiceHealth, string> = {
  up: 'bg-success',
  down: 'bg-critical',
  degraded: 'bg-warning',
  unknown: 'bg-muted-foreground',
};

const statusLabel: Record<ServiceHealth, string> = {
  up: 'Operational',
  down: 'Offline',
  degraded: 'Degraded',
  unknown: 'Unknown',
};

export function StatusIndicator({ label, status, detail }: StatusIndicatorProps) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-border bg-background/40 px-3 py-2.5">
      <div className="flex items-center gap-2.5">
        <span className="relative flex h-2.5 w-2.5">
          {status === 'up' && (
            <span
              className={cn(
                'absolute inline-flex h-full w-full animate-ping rounded-full opacity-60',
                dotColor[status],
              )}
            />
          )}
          <span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full', dotColor[status])} />
        </span>
        <span className="text-sm font-medium text-foreground">{label}</span>
      </div>
      <div className="text-right">
        <p className="text-xs font-medium text-muted-foreground">{statusLabel[status]}</p>
        {detail && <p className="text-[11px] text-muted-foreground/70">{detail}</p>}
      </div>
    </div>
  );
}
